import { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { ChevronDown, Search, PersonFill } from 'react-bootstrap-icons';

// Dropdown for picking a registered bidder (e.g. when recording a deposit),
// so the operator never has to type a raw user id. Searchable by name, email,
// phone, personal number or id.
const fullName = (b) => [b.name, b.surname].filter(Boolean).join(' ') || `#${b.id}`;
const initials = (b) => (`${(b.name || '').charAt(0)}${(b.surname || '').charAt(0)}`).toUpperCase();
const sub = (b) => [b.email, b.phone].filter(Boolean).join(' · ');

const Avatar = ({ bidder }) => {
    const ini = initials(bidder);
    return <span className="admin-bidderpicker-avatar">{ini || <PersonFill />}</span>;
};

const BidderPicker = ({ bidders = [], value, onChange, placeholder }) => {
    const [open, setOpen] = useState(false);
    const [q, setQ] = useState('');

    const selected = bidders.find((b) => String(b.id) === String(value));
    const query = q.trim().toLowerCase();
    const filtered = query
        ? bidders.filter((b) => `${fullName(b)} ${b.email || ''} ${b.phone || ''} ${b.personal_id || ''} ${b.id}`.toLowerCase().includes(query))
        : bidders;

    return (
        <div className="admin-carpicker">
            <button type="button" className={`admin-carpicker-trigger ${open ? 'is-open' : ''}`} onClick={() => setOpen((o) => !o)}>
                {selected ? (
                    <span className="admin-carpicker-sel">
                        <Avatar bidder={selected} />
                        <span className="admin-carpicker-text">
                            <strong>{fullName(selected)}</strong>
                            <span>{selected.email || selected.phone || ''} · id {selected.id}</span>
                        </span>
                    </span>
                ) : (
                    <span className="admin-carpicker-ph">{placeholder}</span>
                )}
                <ChevronDown className="admin-carpicker-caret" />
            </button>

            {open && (
                <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
                    <div className="admin-carpicker-menu">
                        <div className="admin-carpicker-search">
                            <Search />
                            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="ძებნა სახელით, ელფოსტით, ნომრით ან ID-ით" />
                        </div>
                        <div className="admin-carpicker-list">
                            {filtered.length === 0 && (
                                <div className="admin-carpicker-empty">
                                    {bidders.length === 0 ? 'ბიდერი არ არის' : 'ბიდერი ვერ მოიძებნა'}
                                </div>
                            )}
                            {filtered.map((b) => (
                                <button
                                    key={b.id}
                                    type="button"
                                    className={`admin-carpicker-opt ${String(b.id) === String(value) ? 'is-sel' : ''}`}
                                    onClick={() => { onChange(b.id); setOpen(false); setQ(''); }}
                                >
                                    <Avatar bidder={b} />
                                    <span className="admin-carpicker-text">
                                        <strong>{fullName(b)}</strong>
                                        <span>{sub(b)} · id {b.id}</span>
                                    </span>
                                </button>
                            ))}
                        </div>
                    </div>
                </OutsideClickHandler>
            )}
        </div>
    );
};

export default BidderPicker;
